/*
 Created by qing on 2021/7/20
 Des:
 */

import '../../../assets/formula.less'
import CodeMirror from 'codemirror'
import 'codemirror/addon/display/placeholder.js'
import 'codemirror/addon/hint/show-hint.js'


export default {
  install(Vue, opts) {
    const HINT_ELEMENT_CLASS = "CodeMirror-hint"
    const ACTIVE_HINT_ELEMENT_CLASS = "CodeMirror-hint-active"
    CodeMirror.showHint = function (cm, getHints, options) {
      if (!getHints) {
        return cm.showHint(options)
      }
      if (options && options.async) {
        getHints.async = true
      }
      const newOpts = {
        hint: getHints
      }
      if (options) {
        let prop
        for (prop in options) {
          newOpts[prop] = options[prop]
        }
      }
      return cm.showHint(newOpts)
    }
    CodeMirror.defineExtension("showHint", function (options) {
      if (this.listSelections().length > 1 || this.somethingSelected()) {
        return
      }
      if (this.state.completionActive) {
        this.state.completionActive.close()
      }
      const completion = this.state.completionActive = new Completion(this, options)
      if (!completion.options.hint) {
        return
      }
      CodeMirror.signal(this, "startCompletion", this)
      completion.update(true)
    })
    const requestAnimationFrame = window.requestAnimationFrame || function (_nextEventFunc) {
      return setTimeout(_nextEventFunc, 1E3 / 60)
    }
    const cancelAnimationFrame = window.cancelAnimationFrame || clearTimeout
    CodeMirror.registerHelper("hint", "auto", function (cm, options) {
      let helpers = cm.getHelpers(cm.getCursor(), "hint")
      let words
      if (helpers.length) {
        /** @type {number} */
        let i = 0
        for (; i < helpers.length; i++) {
          let parsed = helpers[i](cm, options)
          if (parsed && parsed.list.length) {
            return parsed
          }
        }
      } else {
        words = cm.getHelper(cm.getCursor(), "hintWords")
        if (words) {
          return CodeMirror.hint.fromList(cm, {
            words: words
          })
        } else if (CodeMirror.hint.anyword) {
          return CodeMirror.hint.anyword(cm, options)
        }
      }
    })
    CodeMirror.registerHelper("hint", "fromList", function (cm, set) {
      let cur = cm.getCursor()
      let token = cm.getTokenAt(cur)
      let circleList = []
      let i = 0
      for (; i < set.words.length; i++) {
        let e = set.words[i]
        if (e.slice(0, token.string.length) === token.string) {
          circleList.push(e)
        }
      }
      if (circleList.length) {
        return {
          list: circleList,
          from: CodeMirror.Pos(cur.line, token.start),
          to: CodeMirror.Pos(cur.line, token.end)
        }
      }
    })
    CodeMirror.commands.autocomplete = CodeMirror.showHint
    let defaultOptions = {
      hint: CodeMirror.hint.auto,
      completeSingle: true,
      alignWithWord: true,
      closeCharacters: /[\s()\[\]{};:>,]/,
      closeOnUnfocus: true,
      completeOnSingleClick: false,
      container: null,
      customKeys: null,
      extraKeys: null
    }
    CodeMirror.defineOption("hintOptions", null)

    function Completion(cm, options) {
      this.cm = cm
      this.options = this.buildOptions(options)
      this.widget = null
      this.debounce = 0
      this.tick = 0
      this.startPos = this.cm.getCursor()
      this.startLen = this.cm.getLine(this.startPos.line).length
      const self = this
      cm.on("cursorActivity", this.activityFunc = function () {
        self.cursorActivity()
      })
    }

    Completion.prototype = {
      close: function () {
        if (!this.active()) {
          return
        }
        this.cm.state.completionActive = null
        this.tick = null
        this.cm.off("cursorActivity", this.activityFunc)
        if (this.widget && this.data) {
          CodeMirror.signal(this.data, "close")
        }
        if (this.widget) {
          this.widget.close()
        }
        CodeMirror.signal(this.cm, "endCompletion", this.cm)
      },
      active: function () {
        return this.cm.state.completionActive === this
      },
      pick: function (data, i) {
        const completion = data.list[i]
        if (completion.hint) {
          completion.hint(this.cm, data, completion)
        } else {
          this.cm.replaceRange(getText(completion + "()"), completion.from || data.from, completion.to || data.to, "complete")
        }
        let line = this.cm.getCursor()
        line.ch = line.ch - 1
        this.cm.setCursor(line)
        CodeMirror.signal(data, "pick", completion)
        this.close()
      },
      cursorActivity: function () {
        if (this.debounce) {
          cancelAnimationFrame(this.debounce)
          this.debounce = 0
        }
        const pos = this.cm.getCursor()
        const line = this.cm.getLine(pos.line)
        if (pos.line !== this.startPos.line || line.length - pos.ch !== this.startLen - this.startPos.ch || pos.ch < this.startPos.ch || this.cm.somethingSelected() || pos.ch && this.options.closeCharacters.test(line.charAt(pos.ch - 1))) {
          this.close()
        } else {
          const prevPageButtonSprite = this
          this.debounce = requestAnimationFrame(function () {
            prevPageButtonSprite.update()
          })
          if (this.widget) {
            this.widget.disable()
          }
        }
      },
      update: function (name) {
        if (this.tick == null) {
          return
        }
        if (this.data) {
          CodeMirror.signal(this.data, "update")
        }
        if (!this.options.hint.async) {
          this.finishUpdate(this.options.hint(this.cm, this.options), name)
        } else {
          const myTick = ++this.tick
          const self = this
          this.options.hint(this.cm, function (data) {
            if (self.tick === myTick) {
              self.finishUpdate(data, name)
            }
          }, this.options)
        }
      },
      finishUpdate: function (data, first) {
        this.data = data
        let n = this.widget && this.widget.picked || first && this.options.completeSingle
        if (this.widget) {
          this.widget.close()
        }
        if (data && data.list.length) {
          if (n && data.list.length === 1) {
            this.pick(data, 0)
          } else {
            this.widget = new Widget(this, data)
            CodeMirror.signal(data, "shown")
          }
        }
      },
      buildOptions: function (options) {
        let editor = this.cm.options.hintOptions
        let out = {}
        let prop
        for (prop in defaultOptions) {
          out[prop] = defaultOptions[prop]
        }
        if (editor) {
          for (prop in editor) {
            if (editor[prop] !== undefined) {
              out[prop] = editor[prop]
            }
          }
        }
        if (options) {
          for (prop in options) {
            if (options[prop] !== undefined) {
              out[prop] = options[prop]
            }
          }
        }
        return out
      }
    }

    function getText(completion) {
      if (typeof completion == "string") {
        return completion
      } else {
        return completion.text
      }
    }

    function buildKeyMap(completion, handle) {
      function addBinding(key, val) {
        let bound
        if (typeof val != "string") {
          bound = function (cm) {
            return val(cm, handle)
          }
        } else {
          if (baseMap.hasOwnProperty(val)) {
            bound = baseMap[val]
          } else {
            bound = val
          }
        }
        ourMap[key] = bound
      }

      let baseMap = {
        Up: function () {
          handle.moveFocus(-1)
        },
        Down: function () {
          handle.moveFocus(1)
        },
        PageUp: function () {
          handle.moveFocus(-handle.menuSize() + 1, true)
        },
        PageDown: function () {
          handle.moveFocus(handle.menuSize() - 1, true)
        },
        Home: function () {
          handle.setFocus(0)
        },
        End: function () {
          handle.setFocus(handle.length - 1)
        },
        Enter: handle.pick,
        Tab: handle.pick,
        Esc: handle.close
      }
      let custom = completion.options.customKeys
      let ourMap = custom ? {} : baseMap
      if (custom) {
        let key
        for (key in custom) {
          if (custom.hasOwnProperty(key)) {
            addBinding(key, custom[key])
          }
        }
      }
      let extra = completion.options.extraKeys
      if (extra) {
        for (let key in extra) {
          if (extra.hasOwnProperty(key)) {
            addBinding(key, extra[key])
          }
        }
      }
      return ourMap
    }

    function getHintElement(hintsElement, el) {
      for (; el && el !== hintsElement;) {
        if (el.nodeName.toUpperCase() === "LI" && el.parentNode === hintsElement) {
          return el
        }
        el = el.parentNode
      }
    }

    /**
     * @return {boolean}
     */
    function Widget(completion, data) {
      this.completion = completion
      this.data = data
      this.picked = false
      const widget = this
      const cm = completion.cm
      const hints = this.hints = document.createElement("ul")
      hints.className = "CodeMirror-hints"
      this.selectedHint = data.selectedHint || 0
      const completions = data.list
      for (let i = 0; i < completions.length; i++) {
        const elt = hints.appendChild(document.createElement("li"))
        const cur = completions[i]
        let className = HINT_ELEMENT_CLASS + (i !== this.selectedHint ? "" : " " + ACTIVE_HINT_ELEMENT_CLASS)
        if (cur.className != null) {
          className = cur.className + " " + className
        }
        elt.className = className
        if (cur.render) {
          cur.render(elt, data, cur)
        } else {
          elt.appendChild(document.createTextNode(cur.displayText || getText(cur)))
        }
        elt.hintId = i
      }
      let s = cm.cursorCoords(completion.options.alignWithWord ? data.from : null)
      let left = s.left
      let top = s.bottom
      let size = true
      hints.style.left = left + "px"
      hints.style.top = top + "px"
      let x = window.innerWidth || Math.max(document.body.offsetWidth, document.documentElement.offsetWidth)
      let h = window.innerHeight || Math.max(document.body.offsetHeight, document.documentElement.offsetHeight);
      (completion.options.container || document.body).appendChild(hints)
      let r = hints.getBoundingClientRect()
      let high = r.bottom - h
      if (high > 0) {
        let i = r.bottom - r.top
        let spectrumSize = s.top - (s.bottom - r.top)
        if (spectrumSize - i > 0) {
          hints.style.top = (top = s.top - i) + "px"
          size = false
        } else {
          if (i > h) {
            hints.style.height = h - 5 + "px"
            hints.style.top = (top = s.bottom - r.top) + "px"
            let start = cm.getCursor()
            if (data.from.ch !== start.ch) {
              s = cm.cursorCoords(start)
              hints.style.left = (left = s.left) + "px"
              r = hints.getBoundingClientRect()
            }
          }
        }
      }
      let w = r.right - x
      if (w > 0) {
        if (r.right - r.left > x) {
          hints.style.width = x - 5 + "px"
          w = w - (r.right - r.left - x)
        }
        hints.style.left = (left = s.left - w) + "px"
      }
      cm.addKeyMap(this.keyMap = buildKeyMap(completion, {
        moveFocus: function (n, avoidWrap) {
          widget.changeActive(widget.selectedHint + n, avoidWrap)
        },
        setFocus: function (n) {
          widget.changeActive(n)
        },
        menuSize: function () {
          return widget.screenAmount()
        },
        length: completions.length,
        close: function () {
          completion.close()
        },
        pick: function () {
          widget.pick()
        },
        data: data
      }))
      if (completion.options.closeOnUnfocus) {
        let _takingTooLongTimeout
        cm.on("blur", this.onBlur = function () {
          _takingTooLongTimeout = setTimeout(function () {
            completion.close()
          }, 100)
        })
        cm.on("focus", this.onFocus = function () {
          clearTimeout(_takingTooLongTimeout)
        })
      }
      let localBox = cm.getScrollInfo()
      cm.on("scroll", this.onScroll = function () {
        const curScroll = cm.getScrollInfo()
        const editor = cm.getWrapperElement().getBoundingClientRect()
        const newTop = top + localBox.top - curScroll.top
        let point = newTop - (window.pageYOffset || (document.documentElement || document.body).scrollTop)
        if (!size) {
          point = point + hints.offsetHeight
        }
        if (point <= editor.top || point >= editor.bottom) {
          return completion.close()
        }
        hints.style.top = newTop + "px"
        hints.style.left = left + localBox.left - curScroll.left + "px"
      })
      CodeMirror.on(hints, "dblclick", function (event) {
        const t = getHintElement(hints, event.target || event.srcElement)
        if (t && t.hintId != null) {
          widget.changeActive(t.hintId)
          widget.pick()
        }
      })
      CodeMirror.on(hints, "click", function (event) {
        const t = getHintElement(hints, event.target || event.srcElement)
        if (t && t.hintId != null) {
          widget.changeActive(t.hintId)
          if (completion.options.completeOnSingleClick) {
            widget.pick()
          }
        }
      })
      CodeMirror.on(hints, "mousedown", function () {
        setTimeout(function () {
          cm.focus()
        }, 20)
      })
      CodeMirror.signal(data, "select", completions[0], hints.firstChild)
      return true
    }

    Widget.prototype = {
      close: function () {
        if (this.completion.widget !== this) {
          return
        }
        /** @type {null} */
        this.completion.widget = null
        this.hints.parentNode.removeChild(this.hints)
        this.completion.cm.removeKeyMap(this.keyMap)
        let cm = this.completion.cm
        if (this.completion.options.closeOnUnfocus) {
          cm.off("blur", this.onBlur)
          cm.off("focus", this.onFocus)
        }
        cm.off("scroll", this.onScroll)
      },
      disable: function () {
        this.completion.cm.removeKeyMap(this.keyMap)
        let defaults = this
        this.keyMap = {
          Enter: function () {
            defaults.picked = true
          }
        }
        this.completion.cm.addKeyMap(this.keyMap)
      },
      pick: function () {
        this.completion.pick(this.data, this.selectedHint)
      },
      changeActive: function (i, avoidWrap) {
        if (i >= this.data.list.length) {
          i = avoidWrap ? this.data.list.length - 1 : 0
        } else {
          if (i < 0) {
            i = avoidWrap ? 0 : this.data.list.length - 1
          }
        }
        if (this.selectedHint === i) {
          return
        }
        let node = this.hints.childNodes[this.selectedHint]
        node.className = node.className.replace(" " + ACTIVE_HINT_ELEMENT_CLASS, "")
        node = this.hints.childNodes[this.selectedHint = i]
        node.className += " " + ACTIVE_HINT_ELEMENT_CLASS
        if (node.offsetTop < this.hints.scrollTop) {
          this.hints.scrollTop = node.offsetTop - 3
        } else {
          if (node.offsetTop + node.offsetHeight > this.hints.scrollTop + this.hints.clientHeight) {
            this.hints.scrollTop = node.offsetTop + node.offsetHeight - this.hints.clientHeight + 3
          }
        }
        CodeMirror.signal(this.data, "select", this.data.list[this.selectedHint], node)
      },
      screenAmount: function () {
        return Math.floor(this.hints.clientHeight / this.hints.firstChild.offsetHeight) || 1
      }
    }

    CodeMirror.defineMode("formula", function () {
      function add(patches) {
        const mod = {}
        if (patches) {
          for (let i = 0; i < patches.length; i++) {
            mod[patches[i]] = true
          }
        }
        return mod
      }

      function tokenBase(stream, state) {
        if (stream.eatSpace()) {
          return null
        }
        state = stream.next()
        if (state === '"' || state === "'") {
          next(stream, state)
          return "string"
        }
        if (/[\[\],\(\)]/.test(state)) {
          return "bracket"
        }
        if (/[+\-*\/=<>!&|]/.test(state)) {
          return "operator"
        }
        if (/\d/.test(state)) {
          stream.eatWhile(/[\d\.]/)
          return "number"
        }
        stream.eatWhile(/[\w]/)
        let select = stream.current()
        if (obj.hasOwnProperty(select)) {
          return "atom"
        }
        if (u.hasOwnProperty(select)) {
          return "keyword"
        }
        if (tr.hasOwnProperty(select)) {
          return "deprecate"
        }
        return "negative"
      }

      function next(data, name) {
        let value = false
        let type
        for (; (type = data.next()) != null;) {
          if (type === name && !value) {
            return false
          }
          value = !value && type === "\\"
        }
        return value
      }

      function tokenize(stream, state) {
        return (state.tokens[0] || tokenBase)(stream, state)
      }

      let obj = add(["false", "true"])
      let u = add(CodeMirror.keywords)
      let tr = add(["MAP"])
      return {
        startState: function () {
          return {
            tokens: []
          }
        },
        token: function (src, state) {
          return tokenize(src, state)
        },
        fold: "brace"
      }
    })
    CodeMirror.defineMIME("text/x-formula", "formula")
    CodeMirror.registerHelper("hint", "formula", function (editor, options) {
      let Pos = CodeMirror.Pos

      function scriptHint(editor, keywords, getToken, options) {
        let cur = editor.getCursor()
        let token = getToken(editor, cur)
        if (/\b(?:string)\b/.test(token.type)) {
          return
        }
        token.state = CodeMirror.innerMode(editor.getMode(), token.state).state
        if (!/^[\w$_]*$/.test(token.string)) {
          token = {
            start: cur.ch,
            end: cur.ch,
            string: "",
            state: token.state,
            type: token.string === "." ? "property" : null
          }
        } else {
          if (token.end > cur.ch) {
            token.end = cur.ch
            token.string = token.string.slice(0, cur.ch - token.start)
          }
        }
        let tprop = token
        let context = []
        while (tprop.type === "property") {
          tprop = getToken(editor, Pos(cur.line, tprop.start))
          if (tprop.string !== ".") {
            return
          }
          tprop = getToken(editor, Pos(cur.line, tprop.start))
          context.push(tprop)
        }
        return {
          list: getCompletions(token, context, keywords, options),
          from: Pos(cur.line, token.start),
          to: Pos(cur.line, token.end)
        }
      }

      function getCompletions(token, context, keywords, options) {
        function maybeAdd(v) {
          if (v.lastIndexOf(obj3, 0) === 0 && !indexOf(found, v)) {
            found.push(v)
          }
        }

        let found = []
        let obj3 = token.string.toUpperCase()
        if (!obj3) {
          return found
        }
        if (context && context.length) {
          context.pop()
        } else {
          forEach(keywords, maybeAdd)
        }
        return found
      }

      function forEach(arr, callback) {
        let i = 0
        let arrSize = arr.length
        for (; i < arrSize; ++i) {
          callback(arr[i])
        }
      }

      function indexOf(array, value) {
        if (!Array.prototype.indexOf) {
          let i = array.length
          for (; i--;) {
            if (array[i] === value) {
              return true
            }
          }
          return false
        }
        return array.indexOf(value) !== -1
      }

      return scriptHint(editor, CodeMirror.keywords, function (cm, cur) {
        return cm.getTokenAt(cur)
      }, options)
    })

    window.CodeMirror = CodeMirror
  }
}
